import React, { useState } from "react";
import CurrentOrdersHeader from "../../components/current-orders/currentOrdersHeader";
import CurrentOrdersTable from "../../components/tables/currentOrdersTable";
import OrderHistoryTable from "../../components/tables/orderHistoryTable";
import Topnav from "../../components/topnav/topnav";
import "./currentOrders.css";
import SuppliedOrdersCFA from "../../components/tables/suppliedOrdersCFA";
import { useLocation, useNavigate } from "react-router-dom";

const CurrentOrders = () => {
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <>
      <Topnav />
      <div className="">
        <CurrentOrdersHeader />
      </div>

      <div className="current-orders-table-container m-3">
        <div>
          <button
            onClick={() => navigate("/current-orders")}
            className={
              location.pathname === "/current-orders"
                ? "active-tab px-4 py-2"
                : "inactive-tab px-4 py-2"
            }
          >
            CURRENT ORDERS
          </button>
          <button
            onClick={() => navigate("/orders-hostory")}
            className={
              location.pathname === "/orders-hostory"
                ? "active-tab px-4 py-2"
                : "inactive-tab px-4 py-2"
            }
          >
            ORDERS HISTORY
          </button>
          <button
            onClick={() => navigate("/supplied-order-cfa")}
            className={
              location.pathname === "/supplied-order-cfa"
                ? "active-tab px-4 py-2"
                : "inactive-tab px-4 py-2"
            }
          >
            SUPPLIED ORDERS FROM CFA
          </button>
        </div>
        {location.pathname == "/current-orders" && (
          <CurrentOrdersTable location={location} />
        )}
        {location.pathname == "/orders-hostory" && (
          <OrderHistoryTable location={location} />
        )}
        {location.pathname == "/supplied-order-cfa" && (
          <SuppliedOrdersCFA location={location} />
        )}
      </div>
    </>
  );
};

export default CurrentOrders;
